import React from 'react'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'

import * as interviewSelectors from '../../../interview/selectors'
import { Text } from '../MobileText'

import { StatusNotification, MobileStatusNotification } from './BaseNotifications'

const Label = styled(Text)`
  font-size: 24px;
  line-height: 28px;
  @media screen and (max-width: 2500px) {
    font-size: 20px;
    line-height: 24px;
  }
  @media screen and (max-width: 2000px) {
    font-size: 16px;
    line-height: 19px;
  }
  @media screen and (max-width: 1200px) {
    font-size: 12px;
    line-height: 14px;
  }
  @media screen and (max-width: 900px) {
    font-size: 8px;
    line-height: 9px;
  }
`

const MobileLabel = styled(Text)`
  font-size: 18px;
  font-weight: normal;
  line-height: 21px;
`

export function PeerLeft({ isExpert }: { isExpert: boolean }) {
  const interview = useSelector(interviewSelectors.interview)
  const { peer } = interview
  const label = `${peer.first_name} left the session`

  return (
    <StatusNotification isExpert={isExpert}>
      <Label>{label}</Label>
    </StatusNotification>
  )
}

export function MobilePeerLeft() {
  const interview = useSelector(interviewSelectors.interview)
  const { peer } = interview
  const label = `${peer.first_name} left the session`

  return (
    <MobileStatusNotification>
      <MobileLabel>{label}</MobileLabel>
    </MobileStatusNotification>
  )
}
